import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const BlogCard = ({ blog, index = 0, featured = false }) => (
  <Reveal delay={index * 0.1} className={featured ? "md:col-span-2" : ""}>
    <Link to={`/blogs/${blog.slug}`} className="blog-card group block h-full rounded-3xl overflow-hidden glass" data-testid={`blog-card-${blog.slug}`}>
      <div className={`overflow-hidden ${featured ? "aspect-[21/9]" : "aspect-[16/10]"}`}>
        <img src={blog.cover_image} alt={blog.title} loading="lazy" className="w-full h-full object-cover" />
      </div>
      <div className="p-6 sm:p-8">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-mono uppercase tracking-widest text-[var(--muted)]">
          <span className="text-[var(--saffron-line)]">{blog.tags?.[0]}</span>
          <span className="w-1 h-1 rounded-full bg-current" />
          <span className="flex items-center gap-1 whitespace-nowrap"><Clock size={12} /> {blog.read_time}</span>
        </div>
        <h3 className={`mt-4 font-display font-bold tracking-tight text-[var(--ink)] ${featured ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"}`}>
          {blog.title}
        </h3>
        <p className="mt-3 text-sm sm:text-base text-[var(--ink-soft)] leading-relaxed line-clamp-3">{blog.excerpt}</p>
        <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[var(--ink)]">
          Read
          <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </div>
    </Link>
  </Reveal>
);

export const BlogsSection = ({ blogs, loading }) => (
  <section id="blogs" className="relative py-16 sm:py-28 lg:py-36" data-testid="blogs-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 sm:mb-14">
        <div>
          <p className="eyebrow mb-4">Blogs · by TruCitizen</p>
          <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-[var(--ink)]">
            Read like a citizen<br />who's paying attention.
          </h2>
        </div>
        <Link to="/blogs" className="btn-ghost self-start md:self-auto" data-testid="blogs-view-all-link">
          All blogs <ArrowUpRight size={16} />
        </Link>
      </Reveal>
      {loading ? (
        <div className="grid md:grid-cols-3 gap-6" data-testid="blogs-loading">
          {[0, 1, 2].map((i) => <div key={i} className="h-96 rounded-3xl bg-white/50 animate-pulse" />)}
        </div>
      ) : (
        <div className="grid md:grid-cols-3 gap-6">
          {blogs.map((b, i) => <BlogCard key={b.id} blog={b} index={i} />)}
        </div>
      )}
    </div>
  </section>
);
